import TagLinkCell from '@nile/banyan/src/Pages/ServiceCatalog/TagLinkCell';
import React, { useContext, useEffect, useState, useRef } from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import { withRouter } from 'react-router-dom';
import {
  AppContext,
  BackgroundIcon,
  ContentDeciderContainer,
  DeleteModal,
  getTranslatedText,
  isAuthorised,
  Loader,
  SkeletonTableLoading,
  // TableContainer,
  Tag,
  toast,
  getDefaultValue,
  updateConditions,
  EventEmitter,
  COMMON_CONSTANTS,
  useProduct
} from '@nile/components';
import {
  GET_SERVICE_CATEGORIES,
  AccountClient,
  useQuery,
  GET_WHITELISTED_SERVICE_ITEMS,
  GET_WHITELISTED_SERVICE_ITEMS_LIST,
  GET_OFFERED_ITEMS_LIST,
  GET_SERVICE_ITEMS_FOR_IT
} from '@nile/graphql';
import envConfig from '@nile/home/src/Config/env';
import { TextCell } from '@nile/mangifera/src/Components/Ticket';
import LinkCell from '@nile/banyan/src/Pages/ServiceCatalog/LinkCell';
import TableView from '@nile/banyan/src/Pages/ServiceCatalog/TableView';
import { Button } from '@superops/ui-design-system';
import { SVGIcon } from '@superops/super-icons';
import styled from 'styled-components';
import WorklogContext from '@nile/client_management/src/Contexts/WorklogContext';
import CurrencyCell from '@nile/client_management/src/Pages/Invoice/CurrencyCell';
import AuditBulkSelectCell from '@nile/client_management/src/Pages/Invoice/AuditBulkSelectCell';
import ItemSelectionCell from './ItemSelectionCell';

const ROW_COUNT = 20;

const TableContainer = styled.div`
  height: ${(props) => (props.fitContentHeight ? 'auto' : '100%')};
  .table {
    min-width: 400px !important;
  }

  .columnHeader {
    flex: none !important;
  }

  .tbody {
    display: inline-block;
    overflow: auto;

    .tr {
      min-height: 42px;
    }

    padding-top: 12px;
  }

  .tr .td,
  .inblock {
    padding-left: 4px;
  }

  .unFreezeContent {
    width: 99%;
    overflow: auto;
    white-space: nowrap;
    position: relative;
    // padding-left: 20px;
  }
  .unFreezeContent:hover {
    overflow: auto;
  }
  .cell {
    font-weight: ${(props) => (props.notBold ? '400 !important' : '')};
  }
`;

const TableWrapper = styled(TableContainer)`
  .colHeader {
    margin-left: 8px;
  }
`;

const BulkSelectWrapper = styled.div`
  .Superops-Choice {
    padding-top: 0;
    padding-bottom: 0;
  }
`;

function ItemsToAddTable(props) {
  const { intl, selectedSection, renderServiceItemSheet } = props;
  const [localSelectedSection, setLocalSelectedSection] = useState(
    selectedSection
  );
  const isMSPProduct = useProduct(COMMON_CONSTANTS.MSP);
  const selectedSectionRef = React.useRef(0);
  selectedSectionRef.current = localSelectedSection;
  const loading = false;
  const [columnGroup, setColumnGroup] = useState([
    { Header: 'Name', columns: [] }
  ]);
  const [data, setData] = useState([]);
  const [records, setRecords] = useState([]);
  /**
   * Default options for the list info to use in table
   */
  const [options, setOptions] = useState({
    pageSize: ROW_COUNT,
    page: 1,
    sort: [
      {
        attribute: 'name',
        order: 'DESC'
      }
    ],
    condition: null
  });

  const [listLoading, setListLoading] = useState(true);
  const [listInfo, setListInfo] = useState({});
  const listInfoByRef = useRef(null);
  listInfoByRef.current = listInfo;
  const appContext = useContext(AppContext);
  const { user } = appContext;
  const roleFeatures = user?.role?.roleFeatureList || [];

  const setConditions = (condition) => {
    // fetchViewData(undefined, { ...listInfoByRef.current, page: 1, condition });
  };

  const updateAllConditions = (condition, selectedField) => {
    updateConditions({
      condition,
      selectedField,
      viewConditions: listInfoByRef?.current?.condition || null, // any variable in which conditions are stored for this component
      setConditions: setConditions
    });
  };
  const getType = (col) => {
    switch (col.name) {
      case 'selection':
        return 'Check';
      case 'unitPrice':
        return 'Currency';
      default:
        return 'Text';
    }
  };

  /**
   * Method to get Service items.
   * Call this method to fetch/refetch the data on mounting/sorting/filtering
   * @param {object} personalization
   * @param {object} pageOptions
   */
  const fetchViewData = async (personalization, pageOptions) => {
    setListLoading(true);
    if (selectedSectionRef.current === 'audit') {
      const response = await AccountClient.query({
        query: GET_OFFERED_ITEMS_LIST,
        variables: {
          isBillingQueue: true,
          listInfo: {
            page: pageOptions?.page || 1,
            pageSize: 20,
            condition: {
              joinOperator: 'AND',
              operands: [
                {
                  attribute: 'status',
                  operator: 'is',
                  value: 'APPROVED'
                },
                {
                  attribute: 'client.name',
                  operator: 'is',
                  value: props.client.name
                }
              ]
            }
          }
        },
        fetchPolicy: 'network-only'
      });
      const cols = [
        {
          name: 'selection',
          label: (
            <BulkSelectWrapper className="flex actr jctr">
              <AuditBulkSelectCell
                allAuditItems={response?.data?.getOfferedItems?.items || []}
                checkDisabledItem={props.checkDisabledRow}
              />
            </BulkSelectWrapper>
          )
        },
        {
          name: 'serviceCatalogItem.name',
          label: getTranslatedText(
            intl,
            'invoiceBuilder.itemSelection.list.name'
          )
        },
        {
          name: 'serviceCatalogItem.description',
          label: getTranslatedText(
            intl,
            'invoiceBuilder.itemSelection.list.description'
          )
        },
        {
          name: 'unitPrice',
          label: getTranslatedText(
            intl,
            'invoiceBuilder.itemSelection.list.unitPrice'
          )
        }
      ];
      const columns = cols.map((col, idx) => {
        return {
          Header: col.label,
          accessor: col.name,
          // minWidth: col.name === 'subject' ? 400 : 50,
          width: col.name === 'selection' ? 50 : 200,
          type: getType(col),
          id: col.name,
          disableResizing: false,
          className: 'sticky',
          disableSortBy: true,
          editable: false,
          disableFilters: true,
          actions: {
            onChange: () => {}
            // onChange: debounce(modifyData, 10)
          },
          field: col,
          isBold: col.name === 'unitPrice',
          currentContext: currentContextRef.current
        };
      });
      setListLoading(false);
      setColumnGroup([{ Header: 'Name', columns }]);
      if (response?.data?.getOfferedItems) {
        setData(response.data.getOfferedItems.items);
        setListInfo({
          ...response.data.getOfferedItems.listInfo,
          condition: pageOptions?.condition || listInfo?.condition || null
        });
        return true;
      }
    } else {
      const condition =
        selectedSectionRef.current === 'all'
          ? {
              joinOperator: 'AND',
              operands: [
                {
                  attribute: 'quantityType',
                  operator: 'is',
                  value: 'UNITS'
                }
              ]
            }
          : pageOptions?.condition || {
              joinOperator: 'AND',
              operands: [
                {
                  attribute: 'category.name',
                  operator: 'is',
                  value: selectedSectionRef.current
                },
                {
                  attribute: 'quantityType',
                  operator: 'is',
                  value: 'UNITS'
                }
              ]
            };
      const response = await AccountClient.query({
        query: isMSPProduct
          ? GET_WHITELISTED_SERVICE_ITEMS_LIST
          : GET_SERVICE_ITEMS_FOR_IT,
        fetchPolicy: COMMON_CONSTANTS.CACHE_POLICIES.NO_CACHE,
        variables: {
          clientId: props?.client?.accountId,
          listInfo: {
            page: pageOptions?.page || 1,
            pageSize: 20,
            condition: condition,
            sort: [
              {
                attribute: 'name',
                order: 'ASC'
              }
            ]
          }
        }
      });
      setListLoading(false);
      const cols = [
        {
          name: 'selection',
          label: '  '
        },
        {
          name: 'name',
          label: getTranslatedText(
            intl,
            'invoiceBuilder.itemSelection.list.name'
          )
        },
        {
          name: 'invoiceDescription',
          label: getTranslatedText(
            intl,
            'invoiceBuilder.itemSelection.list.description'
          )
        }
      ];
      if (isMSPProduct) {
        cols.push({
          name: 'unitPrice',
          label: getTranslatedText(
            intl,
            'invoiceBuilder.itemSelection.list.unitPrice'
          )
        });
      }
      const columns = cols.map((col, idx) => {
        return {
          Header: col.label,
          accessor: col.name,
          // minWidth: col.name === 'subject' ? 400 : 50,
          width: col.name === 'selection' ? 50 : 200,
          type: getType(col),
          id: col.name,
          disableResizing: false,
          className: 'sticky',
          disableSortBy: true,
          editable: false,
          disableFilters: true,
          actions: {
            onChange: () => {}
            // onChange: debounce(modifyData, 10)
          },
          field: col,
          isBold: col.name === 'unitPrice'
        };
      });
      setColumnGroup([{ Header: 'Name', columns }]);
      const responseData = isMSPProduct
        ? response?.data?.getWhitelistedServiceItems
        : response?.data?.getServiceItems;
      if (responseData) {
        setData(responseData.items);
        setListInfo({
          ...responseData.listInfo,
          condition: pageOptions?.condition || listInfo?.condition || null
        });
        return true;
      }
    }
  };

  const fetchFilteredData = (text) => {
    const condition = {
      joinOperator: 'OR',
      operands: [
        {
          joinOperator: 'AND',
          operands: [
            {
              attribute: 'name',
              operator: 'contains',
              value: text
            },
            {
              attribute: 'quantityType',
              operator: 'is',
              value: 'UNITS'
            }
          ]
        },
        {
          joinOperator: 'AND',
          operands: [
            {
              attribute: 'invoiceDescription',
              operator: 'contains',
              value: text
            },
            {
              attribute: 'quantityType',
              operator: 'is',
              value: 'UNITS'
            }
          ]
        }
      ]
    };
    fetchViewData(null, { page: 1, pageSize: 20, condition: condition });
  };

  useEffect(() => {
    EventEmitter.subscribe('filterData', fetchFilteredData);
    return function cleanup() {
      EventEmitter.unsubscribe('filterData', fetchFilteredData);
    };
  }, []);

  useEffect(() => {
    setLocalSelectedSection(selectedSection);
  }, [selectedSection]);

  useEffect(() => {
    if (localSelectedSection) {
      fetchViewData();
    }
  }, [localSelectedSection]);

  const defaultColumnCells = {
    Currency: CurrencyCell,
    Check: ItemSelectionCell
  };

  const setSelectedItems = (items) => {
    // props.setRecords(items);
  };

  const context = {
    setRecords: setSelectedItems,
    viewConditions: listInfoByRef?.current?.condition || null
  };

  return (
    <>
      {renderServiceItemSheet(fetchViewData)}
      <TableWrapper>
        <ContentDeciderContainer
          isLoading={loading || !columnGroup[0]?.columns?.length}
          hasContent
          fullHeight
          mainContent={
            <TableView
              noIndicators
              noBulkSelect
              context={context}
              columns={columnGroup}
              data={data || []}
              setData={setData}
              rowCount={ROW_COUNT}
              refreshTable={fetchViewData}
              listInfo={listInfo}
              defaultColumnCells={defaultColumnCells}
              pagination={
                Math.ceil(listInfo.totalCount / listInfo.pageSize) > 1
              }
              pages={Math.ceil(listInfo.totalCount / listInfo.pageSize) || 0}
              recordCount={listInfo.totalCount}
              activePage={listInfo.page || 0}
              isLoading={listLoading}
              fullHeight
              checkDisabledRow={props.checkDisabledRow}
              checkRowHighlight={props.checkRowHighlight}
            />
          }
          loadingContent={<SkeletonTableLoading />}
          notFoundURL={`${envConfig.imageRoot}svg/not-found.svg`}
        />
      </TableWrapper>
    </>
  );
}

export default injectIntl(withRouter(ItemsToAddTable));
